// Ngân hàng câu đố Sát Pháp Tốc Độ (Puzzle Rush - 3 Phút Sinh Tử)
// Tự động phân tầng độ khó từ 1 nước bí đến 5 nước bí

export const PUZZLE_RUSH_DATA = [
  {
    "id": "pr_21",
    "fen": "1Ccrkab2/4n2c1/3a1p2b/7N1/9/p7p/9/4K4/1p2n1p2/9 w - - 0 1",
    "mate": 1,
    "bestmove": "h6g8",
    "title": "Sát Pháp 1 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_29",
    "fen": "2ba2R2/1N1cak3/5rN2/6R2/9/9/9/9/7r1/1cBAKA3 w - - 0 1",
    "mate": 2,
    "bestmove": "g9f9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_34",
    "fen": "3k1p3/4P4/9/9/6CCR/3n4c/2Pn5/8B/5p3/4K4 w - - 0 1",
    "mate": 2,
    "bestmove": "g5g9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_56",
    "fen": "2C1kaR2/4a4/2N6/9/9/9/9/9/3r1p3/4K4 w - - 0 1",
    "mate": 2,
    "bestmove": "g9f9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_103",
    "fen": "302ck5/4P4/3r3P1/6C2/6C2/2p3R2/8R/B2p4B/4p4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "a7a9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_143",
    "fen": "1Cbak4/3Ra1R2/4b1n2/9/9/9/9/9/4p1r2/5K3 w - - 0 1",
    "mate": 2,
    "bestmove": "g8e8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_147",
    "fen": "r4k3/9/9/9/9/4R4/9/9/9/4K4 w - - 0 1",
    "mate": 1,
    "bestmove": "e4f4",
    "title": "Sát Pháp 1 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_149",
    "fen": "2bk1a3/4a4/4cc3/2N1C4/9/9/9/4B1n2/5p3/C3K1B2 w - - 0 1",
    "mate": 2,
    "bestmove": "c6b8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_166",
    "fen": "5a3/4a4/3kb2NC/9/9/9/9/3C5/5p1n1/3AK1c2 w - - 0 1",
    "mate": 2,
    "bestmove": "h7f6",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_201",
    "fen": "3aka3/9/4c1N2/1C7/9/9/1r5n1/C3B4/4A4/4KAB2 w - - 0 1",
    "mate": 2,
    "bestmove": "a2a9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_208",
    "fen": "2bk1a3/2R3R2/4ba3/9/9/9/3rc4/4B4/4A4/4KAB2 w - - 0 1",
    "mate": 2,
    "bestmove": "g8d8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_307",
    "fen": "339/9/4k4/9/9/9/9/3pppR2/5pR2/4K1B2 w - - 0 1",
    "mate": 1,
    "bestmove": "d3d8",
    "title": "Sát Pháp 1 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_331",
    "fen": "2r1kab2/3Ra4/4b4/4C4/9/6R2/9/9/3cp4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "d8e8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_381",
    "fen": "5a3/3k3N1/1R1cba3/6N2/5r3/9/9/9/4p4/3K2B2 w - - 0 1",
    "mate": 2,
    "bestmove": "b7d7",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_382",
    "fen": "3aka3/9/9/5N2C/9/9/4c2n1/4B4/4A4/3AK4 w - - 0 1",
    "mate": 2,
    "bestmove": "f6g8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_426",
    "fen": "1R1ak4/1Cr1aR3/4b4/9/9/9/9/B3B4/2r1p4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "f8e8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_434",
    "fen": "2bak1r2/4aP3/4b4/4C4/9/2R6/9/9/3p5/4K4 w - - 0 1",
    "mate": 2,
    "bestmove": "f8e8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_445",
    "fen": "5kc1c/1C2P4/b4N3/4P4/9/9/9/9/4p3r/2RK5 w - - 0 1",
    "mate": 2,
    "bestmove": "c0c9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_467",
    "fen": "1r3ab2/3kaP3/2R6/2N6/2b1p4/2C6/9/1n1AB4/4A4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "c7b7",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_517",
    "fen": "4kab2/4a4/2N1b4/9/9/1R7/5r3/2c1BA3/6n2/2BA1KC2 w - - 0 1",
    "mate": 2,
    "bestmove": "b4b9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_520",
    "fen": "3ak2C1/4a1c2/4b2N1/9/9/9/9/3RB4/2r1p4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "d2d9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_530",
    "fen": "3akr3/2R1a4/9/3N5/9/9/9/9/4p4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "c8e8",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_561",
    "fen": "3akc3/5R3/9/4pN3/8C/9/1r7/9/4p4/3K5 w - - 0 1",
    "mate": 2,
    "bestmove": "i5e5",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_568",
    "fen": "3ak4/4a1P2/9/9/9/9/9/9/9/4K4 w - - 0 1",
    "mate": 1,
    "bestmove": "g8f8",
    "title": "Sát Pháp 1 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_582",
    "fen": "3akab2/6P2/4b3c/9/9/7C1/9/4BR3/2r1p4/2BK5 w - - 0 1",
    "mate": 2,
    "bestmove": "f2f9",
    "title": "Sát Pháp 2 Nước Bí",
    "difficulty": "Dễ"
  },
  {
    "id": "pr_85",
    "fen": "5n3/3ka4/3a5/8p/5CC1c/9/9/3A5/5p3/4KA3 w - - 0 1",
    "mate": 3,
    "bestmove": "f5f8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_86",
    "fen": "2baka3/3RnR3/4b4/9/1r1cp4/2C6/9/4BC3/5p3/2B1KA1r1 w - - 0 1",
    "mate": 3,
    "bestmove": "f8f9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_91",
    "fen": "3a5/5k3/4ba3/1C1N5/9/9/9/4C4/5p3/2B1KAr2 w - - 0 1",
    "mate": 3,
    "bestmove": "e2f2",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_92",
    "fen": "3ak4/4a1R2/4b4/6N2/1r2N4/9/9/9/5p3/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "g8g9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_97",
    "fen": "2Rak4/3Ra4/9/9/9/9/9/2C6/2p1r4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "c9d9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_101",
    "fen": "3ak4/9/2Ca5/9/7R1/9/7p1/4C4/4p2r1/2B2K3 w - - 0 1",
    "mate": 3,
    "bestmove": "h5h9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_115",
    "fen": "1rbak4/1N1Ra4/cR2b1N2/9/9/9/9/4B4/4Ap1r1/2BAK4 w - - 0 1",
    "mate": 3,
    "bestmove": "d8d9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_145",
    "fen": "4kabC1/1R2a2R1/4b4/9/9/9/9/9/3r1r3/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "h8e8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_162",
    "fen": "4k4/4aR3/5a3/4N4/4C4/9/2n6/2r6/3KAp3/5A3 w - - 0 1",
    "mate": 3,
    "bestmove": "f8f9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_171",
    "fen": "9/3k5/4c4/4N4/9/6R2/9/5p3/4r4/5K3 w - - 0 1",
    "mate": 3,
    "bestmove": "g4g8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_177",
    "fen": "2b1ka1R1/4aR3/4b4/4N4/9/9/1r7/9/4p4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "f8e8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_184",
    "fen": "5ab2/3ka4/2R1n4/2Nc5/9/9/9/4B4/2r1A4/3AK4 w - - 0 1",
    "mate": 3,
    "bestmove": "c7c8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_186",
    "fen": "2ba2r2/3kn4/4b4/5R3/5n1r1/1N2NC3/4c4/4B4/2c1A4/2BAK4 w - - 0 1",
    "mate": 3,
    "bestmove": "b4c6",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_197",
    "fen": "4k4/3Pa4/4b4/9/2b2N3/7R1/9/9/2rp5/4KA3 w - - 0 1",
    "mate": 3,
    "bestmove": "d8e8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_207",
    "fen": "3aka3/9/9/6C2/2n6/9/9/4C4/9/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "g6e6",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_241",
    "fen": "4ka3/9/5a3/4p4/6C2/9/9/7RC/2r1p4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "g5g9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_242",
    "fen": "3a1k2C/2c1a4/6C2/9/9/7R1/1r1n5/9/4A1c2/4PAB2 w - - 0 1",
    "mate": 3,
    "bestmove": "h4h9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_271",
    "fen": "2b1kab2/4a4/4c4/9/9/3R5/9/1C7/4r4/2BK2B2 w - - 0 1",
    "mate": 3,
    "bestmove": "b2b9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_272",
    "fen": "1C2kab2/4aP3/4c4/9/9/2R6/9/5A2B/3p1r3/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "c4c9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_287",
    "fen": "5a3/9/3kb4/2N6/9/6C2/7R1/1n1p5/4p4/5K3 w - - 0 1",
    "mate": 3,
    "bestmove": "h3h7",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_299",
    "fen": "3ak1r2/1P3R3/3a5/9/9/9/8n/3p5/9/2B1CKB2 w - - 0 1",
    "mate": 3,
    "bestmove": "f8e8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_320",
    "fen": "3a1k3/4a4/6R2/8R/2r6/9/9/1r7/4A4/3K1A3 w - - 0 1",
    "mate": 3,
    "bestmove": "i6i9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_329",
    "fen": "1C2kab2/4a2R1/2R1c4/9/9/2B6/9/9/4p1r2/5K3 w - - 0 1",
    "mate": 3,
    "bestmove": "c7c9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_346",
    "fen": "4k4/2Nra4/5a3/2R4R1/9/9/9/9/3rp4/5K3 w - - 0 1",
    "mate": 3,
    "bestmove": "h6h9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_352",
    "fen": "3k1a3/1NR2n3/3a5/1r4CC1/2b6/9/9/9/1c1p3r1/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "g6g9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_356",
    "fen": "5k1P1/1R2a4/5a3/9/2n1r4/9/9/4C4/4p4/2B2KB2 w - - 0 1",
    "mate": 3,
    "bestmove": "h9g9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_358",
    "fen": "2ba5/5k3/3Nb1P2/9/9/6R2/9/4B4/2r2p3/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "g7f7",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_372",
    "fen": "2bk3r1/2P1a4/4c4/5N3/4C4/5R3/9/6p1B/4A4/1cBA1K3 w - - 0 1",
    "mate": 3,
    "bestmove": "f4d4",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_373",
    "fen": "2bak4/4aR3/4b1n2/6C2/9/8R/9/9/2p1r4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "i4i9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_390",
    "fen": "3a1k3/4a4/6R2/8R/2r6/9/1r7/9/4A4/3K1A3 w - - 0 1",
    "mate": 3,
    "bestmove": "i6i9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_394",
    "fen": "2b2k3/1R2a2R1/4ba3/4C4/9/9/9/4B3n/6r2/2B2K2c w - - 0 1",
    "mate": 3,
    "bestmove": "h8f8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_415",
    "fen": "1n1k1a3/R8/3ab3n/9/9/6C2/9/4C4/3pAr3/2R1KAB1c w - - 0 1",
    "mate": 3,
    "bestmove": "g4d4",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_429",
    "fen": "3ak4/4a2N1/4c4/9/9/1R7/9/9/2p1r4/3K1R3 w - - 0 1",
    "mate": 3,
    "bestmove": "f0f9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_432",
    "fen": "2Ra5/3k5/2n3C2/9/9/9/9/6r2/4A4/3CKAB2 w - - 0 1",
    "mate": 3,
    "bestmove": "c9c8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_435",
    "fen": "3a3nC/1R4c2/2C1k2r1/9/9/r6N1/9/9/4p4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "h4g6",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_439",
    "fen": "3akab2/Rc1Pn4/7C1/6pN1/1r7/9/9/4B4/3p5/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "h7e7",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_477",
    "fen": "2ba5/5k3/4ba3/3N5/4P4/8C/n8/9/4p4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "i4f4",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_479",
    "fen": "2RNk4/9/1N7/9/1n7/9/C7r/9/2c1p4/2c2K3 w - - 0 1",
    "mate": 3,
    "bestmove": "d9c7",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_499",
    "fen": "2ca1k3/4a1P2/1n7/5N3/9/4R4/9/3A5/3p3r1/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "g8g9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_501",
    "fen": "C1bakr3/3RC1R2/2n1b4/4p4/6n2/9/9/4B4/6p2/4KABc1 w - - 0 1",
    "mate": 3,
    "bestmove": "e8e6",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_521",
    "fen": "3ak4/4a4/4b4/2r1C4/6N2/9/9/5R3/1p7/c2K2B2 w - - 0 1",
    "mate": 3,
    "bestmove": "g5f7",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_526",
    "fen": "5kb2/4a1R2/4brN2/4C4/9/9/9/9/4p4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "g8g9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_535",
    "fen": "3a1k3/2r1a4/9/4C3N/9/9/9/9/2p6/4KA3 w - - 0 1",
    "mate": 3,
    "bestmove": "i6h8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_541",
    "fen": "2Ck1a3/4a4/9/5N3/9/9/5r3/3CB4/4p4/3K2B2 w - - 0 1",
    "mate": 3,
    "bestmove": "f6d7",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_547",
    "fen": "1rbak3r/1N1Ra4/cR2b1N2/9/9/9/9/9/5p3/4K4 w - - 0 1",
    "mate": 3,
    "bestmove": "d8d9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_556",
    "fen": "2bak4/9/4b4/7N1/9/9/9/4BR3/3rp4/2B2K3 w - - 0 1",
    "mate": 3,
    "bestmove": "h6g8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_558",
    "fen": "2bk5/4aR3/c2cb4/9/9/9/9/1C5R1/2r1p4/3K5 w - - 0 1",
    "mate": 3,
    "bestmove": "b2b9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_560",
    "fen": "2bk5/r3aR3/n1r1b4/9/9/6R2/9/3n5/4p4/1C3K3 w - - 0 1",
    "mate": 3,
    "bestmove": "b0b9",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_581",
    "fen": "3a1kb2/4a1P2/4b4/3N5/9/6R2/9/4c4/3r1p3/3AKAB2 w - - 0 1",
    "mate": 3,
    "bestmove": "g8f8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_587",
    "fen": "9/3kaP3/3ab4/4R4/3Rp4/9/7rc/4B4/4p4/5KB2 w - - 0 1",
    "mate": 3,
    "bestmove": "f8e8",
    "title": "Sát Pháp 3 Nước Bí",
    "difficulty": "Trung Bình"
  },
  {
    "id": "pr_5",
    "fen": "3k5/4a4/3aP4/7nR/9/9/9/6R2/3p3r1/4K4 w - - 0 1",
    "mate": 5,
    "bestmove": "i6i9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_6",
    "fen": "4kC3/3RaP3/3C2n1c/Nr1R5/9/9/9/4p4/6r2/4K4 w - - 0 1",
    "mate": 5,
    "bestmove": "f8e8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_14",
    "fen": "4rc3/4ak3/9/9/9/9/9/2R6/3pA4/cr1AKC3 w - - 0 1",
    "mate": 5,
    "bestmove": "c2f2",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_15",
    "fen": "2bk1a3/1R2RN3/c3ba3/2n6/9/1C7/9/9/3r1p2r/1Cc1K4 w - - 0 1",
    "mate": 5,
    "bestmove": "b8d8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_16",
    "fen": "3k5/4a4/4b4/4N4/9/4p4/1R1C2r2/4B4/5p3/3AK4 w - - 0 1",
    "mate": 4,
    "bestmove": "e6c7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_18",
    "fen": "2bak1bRC/c3a4/9/6p2/7N1/1N7/5C3/5p3/4p1rn1/3p1K3 w - - 0 1",
    "mate": 4,
    "bestmove": "f3e3",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_19",
    "fen": "2bak1b2/4aR2C/6N1n/9/9/9/5c3/4BC3/3p1r1n1/4K2c1 w - - 0 1",
    "mate": 4,
    "bestmove": "i8i9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_20",
    "fen": "9/3k5/R2abN2C/C3P4/2b6/9/9/4p4/2r6/cr1AK4 w - - 0 1",
    "mate": 4,
    "bestmove": "a6d6",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_23",
    "fen": "3a2b2/9/3k1a3/2N3NR1/2b1C4/7R1/9/2n4C1/3rAr3/c3K4 w - - 0 1",
    "mate": 4,
    "bestmove": "g6f8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_24",
    "fen": "9/C1r1ak3/n3R4/9/9/2R6/5p3/4B1n2/3p1K3/3A5 w - - 0 1",
    "mate": 5,
    "bestmove": "e7e8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_27",
    "fen": "3ak4/4a4/9/2R6/9/4R4/9/8B/3p1r3/4KABc1 w - - 0 1",
    "mate": 5,
    "bestmove": "e4e8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_28",
    "fen": "9/r2k5/1R1ab4/3N5/2b6/1C7/9/3n1p3/9/5K3 w - - 0 1",
    "mate": 4,
    "bestmove": "b7d7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_30",
    "fen": "4k4/3Ra4/b8/4p4/3R5/C4c1n1/7C1/4B4/1n1KA4/2r3B2 w - - 0 1",
    "mate": 4,
    "bestmove": "d8e8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_32",
    "fen": "3ak4/4aR3/n3N4/4P4/2b6/8C/4c4/N3B1n2/1r2A4/3RKAr2 w - - 0 1",
    "mate": 5,
    "bestmove": "f8f9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_33",
    "fen": "C3ka3/4aP1r1/nR2c4/p8/6b2/9/9/2C6/3p1p3/c1rAK4 w - - 0 1",
    "mate": 5,
    "bestmove": "b7b9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_36",
    "fen": "4ka3/1N2a4/4c4/9/9/3R3R1/4c4/4B4/4A1rn1/3AK1B2 w - - 0 1",
    "mate": 4,
    "bestmove": "d4d9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_37",
    "fen": "2bak4/3Na3C/r1n1b4/7R1/9/9/9/9/4r4/3K5 w - - 0 1",
    "mate": 5,
    "bestmove": "h6h9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_41",
    "fen": "3aka3/5P3/9/9/9/1R5N1/9/4B4/4p2r1/5K3 w - - 0 1",
    "mate": 4,
    "bestmove": "b4e4",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_43",
    "fen": "4k1b2/4aP3/3a5/9/R1C6/9/9/9/4r1p2/5K3 w - - 0 1",
    "mate": 5,
    "bestmove": "a5a9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_45",
    "fen": "2bak4/C2Ra4/N3b3R/1C5n1/9/2Bn5/9/B8/c1rp1p3/4Kc3 w - - 0 1",
    "mate": 4,
    "bestmove": "i7i9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_52",
    "fen": "r3ka3/4aR1N1/9/9/4N1b2/9/9/9/3p5/4K4 w - - 0 1",
    "mate": 4,
    "bestmove": "e5d7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_53",
    "fen": "3k1a3/2R1a4/b2n2R1b/7N1/9/3N5/3p5/9/3r1p3/3AKABc1 w - - 0 1",
    "mate": 5,
    "bestmove": "g7d7",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_54",
    "fen": "5a3/3k1P3/4b2C1/9/9/1N2p4/9/6n2/3p5/4K4 w - - 0 1",
    "mate": 4,
    "bestmove": "b4c6",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_55",
    "fen": "4k4/4a4/2P5n/5N3/9/5R3/9/9/2p2p2r/C3K4 w - - 0 1",
    "mate": 4,
    "bestmove": "f6d7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_62",
    "fen": "5k3/4a4/5a2r/9/1r2N4/4R2R1/9/9/3p5/4K1B2 w - - 0 1",
    "mate": 4,
    "bestmove": "h4h9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_64",
    "fen": "2bakc3/1C2a1n2/4b2Rr/9/2P3N2/9/5n3/2C1B4/4A4/4KAB1c w - - 0 1",
    "mate": 4,
    "bestmove": "h7e7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_72",
    "fen": "2bak2C1/4a4/4b2N1/9/9/9/9/1R2B4/2r1p4/3K5 w - - 0 1",
    "mate": 4,
    "bestmove": "h7g9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_75",
    "fen": "3k5/9/3a5/6N2/9/C1R6/1r7/9/4r4/3K5 w - - 0 1",
    "mate": 5,
    "bestmove": "c4c9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_77",
    "fen": "2bak4/4a4/r3b3c/1C5N1/9/9/9/3R5/4p4/3K5 w - - 0 1",
    "mate": 4,
    "bestmove": "h6f7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_79",
    "fen": "4ka1r1/4aR1R1/9/9/3N5/9/9/9/4p1p2/5K3 w - - 0 1",
    "mate": 5,
    "bestmove": "f8e8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_80",
    "fen": "3aka1r1/9/4b4/6N2/9/1R1R5/9/4B4/4p2r1/5K3 w - - 0 1",
    "mate": 5,
    "bestmove": "d4d9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_81",
    "fen": "3a1a3/3k5/4b4/9/N8/9/8n/C3B4/4p4/5K3 w - - 0 1",
    "mate": 4,
    "bestmove": "a5b7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_82",
    "fen": "2b6/3kaR3/2PaN1n2/9/9/6C2/9/2n6/3p5/1c2KA3 w - - 0 1",
    "mate": 5,
    "bestmove": "c7c8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_83",
    "fen": "3k5/2P1a4/4c4/1rp2N3/5Rb2/9/9/4C4/4p1r2/5K3 w - - 0 1",
    "mate": 5,
    "bestmove": "f5d5",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_84",
    "fen": "2b1ka3/cR2aP1c1/4b4/4CR3/9/9/9/9/r4p3/4K4 w - - 0 1",
    "mate": 4,
    "bestmove": "f8f9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_87",
    "fen": "r3k4/4a4/1R2b4/5R1N1/9/9/9/9/3p2r2/4K4 w - - 0 1",
    "mate": 5,
    "bestmove": "h6f7",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_89",
    "fen": "2baka3/9/4b4/5R2N/2n6/3Rc2N1/r8/3AB4/3KA4/2r6 w - - 0 1",
    "mate": 5,
    "bestmove": "f6f9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_95",
    "fen": "2ba1k1r1/4a4/4b4/3RC2r1/9/3R5/9/5A3/4AK3/9 w - - 0 1",
    "mate": 5,
    "bestmove": "d6d9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_96",
    "fen": "2ba1k3/3Pa1R2/4b4/6N1C/9/9/9/4B4/1r3p3/4K2c1 w - - 0 1",
    "mate": 5,
    "bestmove": "g8g9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_98",
    "fen": "3k2b2/4a1N2/3ab4/9/9/3R1R3/1r7/4B4/4r4/c2K1CB2 w - - 0 1",
    "mate": 5,
    "bestmove": "f4f9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_100",
    "fen": "2ba1k3/4a4/4b4/2R6/6p2/2CR5/9/9/7c1/3AKAr1c w - - 0 1",
    "mate": 5,
    "bestmove": "c4c9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_102",
    "fen": "3k2p2/4P4/9/9/9/2B1cnN2/9/7CR/4p4/2Cp1K3 w - - 0 1",
    "mate": 4,
    "bestmove": "h2h9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_104",
    "fen": "2b1ka3/3Ra4/1c2b3c/N8/R8/6B2/4C1r2/C8/4Ap1n1/3AK4 w - - 0 1",
    "mate": 5,
    "bestmove": "d8d9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_105",
    "fen": "2bak4/4a4/5c1c1/1N3R2N/2p6/4R4/9/5A3/1n1KA4/2r3B2 w - - 0 1",
    "mate": 5,
    "bestmove": "b6c8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_107",
    "fen": "3N1a3/3k5/4R4/1n7/R8/9/9/9/5rn2/C2AKABc1 w - - 0 1",
    "mate": 4,
    "bestmove": "a5d5",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_110",
    "fen": "2b2k3/4a1P2/n3ba3/6C2/9/3RC4/9/9/4r1p2/5K3 w - - 0 1",
    "mate": 4,
    "bestmove": "d4d9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_113",
    "fen": "3k1a3/4a4/9/2R6/N8/9/6n2/5K3/4r4/9 w - - 0 1",
    "mate": 5,
    "bestmove": "c6c9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_117",
    "fen": "2r3b2/5k3/4N4/4p3C/9/6RC1/9/9/1n1KAr3/5A3 w - - 0 1",
    "mate": 5,
    "bestmove": "g4g8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_119",
    "fen": "1CbakN3/4aP3/4b4/9/9/9/9/3R1Ap1B/4AK2c/7r1 w - - 0 1",
    "mate": 4,
    "bestmove": "f8e8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_120",
    "fen": "2bak1b2/4aR3/9/3NR4/9/n8/9/9/2r2p3/4K4 w - - 0 1",
    "mate": 5,
    "bestmove": "f8f9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_133",
    "fen": "2b1ka3/4aR3/b3cn2R/9/9/9/9/BC7/2r2p3/4KA3 w - - 0 1",
    "mate": 5,
    "bestmove": "f8e8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_138",
    "fen": "2brka3/9/9/2R2R2N/9/9/9/3AB4/1r2p4/3K2B2 w - - 0 1",
    "mate": 4,
    "bestmove": "f6f9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_142",
    "fen": "c2a1k3/3Ra4/4c1P2/7R1/9/9/9/1C2B4/1r7/2BK5 w - - 0 1",
    "mate": 5,
    "bestmove": "b2b9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_148",
    "fen": "3N2b2/9/3k5/4P4/2b5n/9/9/9/3p5/4K4 w - - 0 1",
    "mate": 4,
    "bestmove": "e6d6",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_152",
    "fen": "2ba5/4ak3/2N1b4/1C7/9/7R1/9/9/r3r4/3K5 w - - 0 1",
    "mate": 5,
    "bestmove": "h4f4",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_155",
    "fen": "3a1k2r/4a1P2/9/6R2/9/6R2/9/9/2r6/4K4 w - - 0 1",
    "mate": 4,
    "bestmove": "g8f8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_157",
    "fen": "3ak3r/4a1R2/b1C1bc3/1N2C3N/9/3p5/2n6/3K5/9/r8 w - - 0 1",
    "mate": 5,
    "bestmove": "g8g9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_160",
    "fen": "5a3/4k4/4ba1n1/9/4N4/4C4/3c5/6R2/2r1p4/3K2B2 w - - 0 1",
    "mate": 4,
    "bestmove": "g2g8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_161",
    "fen": "2bak4/4aR3/c3b2r1/2R1C4/9/9/9/9/1r7/3AK4 w - - 0 1",
    "mate": 5,
    "bestmove": "f8e8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_168",
    "fen": "2ba2n2/4ak3/4b4/4R4/4N4/9/9/5C3/3rAp3/c1rAK4 w - - 0 1",
    "mate": 4,
    "bestmove": "e6f6",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_169",
    "fen": "2ba1ab2/4k4/9/9/4C1N2/3C5/9/6n1r/9/2BAK4 w - - 0 1",
    "mate": 5,
    "bestmove": "g5e6",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_173",
    "fen": "2b6/3ka4/2Pa5/3N5/9/3R5/9/9/5pr2/3AK4 w - - 0 1",
    "mate": 4,
    "bestmove": "c7d7",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_180",
    "fen": "4ka3/4a1C2/4b4/9/4p2r1/2R5C/9/5n3/4p4/3K2B2 w - - 0 1",
    "mate": 5,
    "bestmove": "c4c9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_182",
    "fen": "4ka3/3P1P3/4b4/9/9/9/9/9/3p2p2/4K4 w - - 0 1",
    "mate": 4,
    "bestmove": "e0f0",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_183",
    "fen": "C3kab2/2P1a4/N8/9/9/9/9/3pB4/2r6/2BK5 w - - 0 1",
    "mate": 4,
    "bestmove": "a7b9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_185",
    "fen": "C3ka3/4aPP2/2N1b4/9/9/9/9/4C4/r1r6/3K5 w - - 0 1",
    "mate": 5,
    "bestmove": "f8f9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_187",
    "fen": "3a5/5k3/4b4/C1R6/5r3/9/9/4pA1R1/4r4/5K3 w - - 0 1",
    "mate": 5,
    "bestmove": "h2h8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_191",
    "fen": "3ak4/4a2r1/4P4/9/4Nc2R/7n1/9/2n6/5p3/2B1K1B2 w - - 0 1",
    "mate": 5,
    "bestmove": "e5f7",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_198",
    "fen": "4k4/4arNR1/3a1r3/1R7/9/9/9/9/4p4/3K5 w - - 0 1",
    "mate": 5,
    "bestmove": "h8h9",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_199",
    "fen": "3a1a3/3R5/4bk3/9/8N/8C/9/1r2B4/4r4/3K2B2 w - - 0 1",
    "mate": 5,
    "bestmove": "d8f8",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_202",
    "fen": "3ak1b2/4a4/4b4/9/6N2/9/6r2/4C3C/4p4/2B2K3 w - - 0 1",
    "mate": 4,
    "bestmove": "i2i9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_204",
    "fen": "2b1ka1n1/4a4/4b4/9/4NR3/2n6/5R3/3AC4/3KA4/r1r6 w - - 0 1",
    "mate": 5,
    "bestmove": "e5d7",
    "title": "Sát Pháp 5 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_209",
    "fen": "RC3kb2/3ra1N2/4ba3/5R3/9/9/9/9/3pA4/4KAnc1 w - - 0 1",
    "mate": 4,
    "bestmove": "b9b8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_210",
    "fen": "r2k5/9/2P6/9/6bN1/4R4/9/2np1pn2/4K4/9 w - - 0 1",
    "mate": 4,
    "bestmove": "e4e9",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  },
  {
    "id": "pr_213",
    "fen": "3rk1b2/1R5R1/5a3/1N7/r8/9/9/4B4/9/2B2K3 w - - 0 1",
    "mate": 4,
    "bestmove": "b6c8",
    "title": "Sát Pháp 4 Nước Bí",
    "difficulty": "Khó"
  }
];

export default PUZZLE_RUSH_DATA;
